import { apiAgent } from "../../config/axiosConfig";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  updateLoadError,
  setLoadingState,
  setSavingState,
  setTestScenarioBuildList,
} from "./testScenarioBuildSlice";

const createBuild = createAsyncThunk(
  "createBuild",
  async (
    { testScenarioId, environmentSetId },
    { dispatch, rejectWithValue }
  ) => {
    await dispatch(setSavingState(true));

    try {
      const response = await apiAgent({
        method: "POST",
        url: "/api/v1/test_scenario_builds",
        data: {
          test_scenario_id: testScenarioId,
          environment_set_id: environmentSetId,
        },
      });

      await dispatch(setSavingState(false));

      if (response.status === 200) return response?.data;

      return rejectWithValue(response.data);
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

const getBuild = createAsyncThunk(
  "getBuild",
  async ({ testScenarioBuildId }, { dispatch, rejectWithValue }) => {
    await dispatch(setLoadingState(true));
    try {
      const response = await apiAgent({
        method: "GET",
        url: `/api/v1/test_scenario_builds/${testScenarioBuildId}`,
      });
      if (response.status === 200) {
        await dispatch(setLoadingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
      await dispatch(setLoadingState(false));
    }
  }
);

const getAllBuilds = createAsyncThunk(
  "getAllBuilds",
  async (
    { testScenarioId, projectId, pageNumber, pageSize, filters },
    { dispatch, rejectWithValue }
  ) => {
    let paramsObj = {
      page: pageNumber,
      page_size: pageSize,
    };
    if (testScenarioId) paramsObj.test_scenario_id = testScenarioId;
    if (projectId) paramsObj.project_id = projectId;
    if (filters) paramsObj = { ...paramsObj, ...filters };
    await dispatch(setLoadingState(true));
    try {
      const response = await apiAgent({
        method: "GET",
        url: "/api/v1/test_scenario_builds/",
        params: paramsObj,
      });
      if (response.status === 200) {
        await dispatch(setTestScenarioBuildList(response?.data || []));
        await dispatch(setLoadingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
      await dispatch(setLoadingState(false));
    }
  }
);

const getBuildLogs = createAsyncThunk(
  "getBuildLogs",
  async ({ parentLogId, buildId }, { dispatch, rejectWithValue }) => {
    await dispatch(setLoadingState(true));
    try {
      const paramsStr = parentLogId ? `&parent_log_id=${parentLogId}` : "";
      const response = await apiAgent({
        method: "GET",
        url: `/api/v1/test_build_logs/?test_scenario_build_id=${buildId}${paramsStr}`,
      });
      if (response.status === 200) {
        await dispatch(setLoadingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

const generateBuildReport = createAsyncThunk(
  "generateBuildReport",
  async ({ testScenarioBuildId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiAgent({
        method: "POST",
        url: `/api/v1/test_scenario_builds/${testScenarioBuildId}/analyse`,
      });
      if (response.status === 200) {
        return response?.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

export { createBuild, getBuild, getAllBuilds, getBuildLogs, generateBuildReport };
